import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceUnhappySVG = function FaceUnhappySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm5.6,16-.37,0a22.73,22.73,0,0,0-5.39,1.09h0l-.51.18a22.54,22.54,0,0,0-2.26,1c-.6.32-1.17.65-1.69,1L11,21.6h0l-.26.18a1,1,0,0,0,1.13,1.65c.1-.08.31-.21.6-.39h0l.37-.23c.37-.22.77-.45,1.19-.67a18.57,18.57,0,0,1,2.43-1.08h0l.55-.18a21.39,21.39,0,0,1,4.41-.82h0l.31,0a1,1,0,1,0-.1-2ZM12,11a2,2,0,1,0,2,2A2,2,0,0,0,12,11Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,20,11Z"
  }));
};
FaceUnhappySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceUnhappySVG);